module.exports = "https://bin.bnbstatic.com/_next/static/images/binance life 3-4762a6f393938de9f570b1a8007297f6.jpg";